module.exports = __webpack_public_path__ + "static/media/3.f614eb39.jpg";